export interface IApiLinkedAccounts {
  Apple?: boolean;
  Google?: boolean;
  Facebook?: boolean;
}

export default class LinkedAccounts {
  apple: boolean;
  google: boolean;
  facebook: boolean;

  constructor() {
    this.apple = false;
    this.google = false;
    this.facebook = false;
  }

  static mappingObject(_obj: IApiLinkedAccounts): LinkedAccounts {
    const obj = new LinkedAccounts();
    obj.apple = _obj.Apple || false;
    obj.google = _obj.Google || false;
    obj.facebook = _obj.Facebook || false;
    return obj;
  }
}
